export default __webpack_public_path__ + "static/Cryptocurrency-Solutions-6b7c91749f96a55a60b17dec4742b511.webp";